/**
 * urs-lrc-parser.js — F1S2-02
 * Karaoke lyrics sync (LRC format [mm:ss.xx]Text).
 * Exposes: window.URS.LRC.parse(text) and window.URS.LRC.attach(audio, container, lines).
 * Fallback: if text has no [time] markers, returns null (caller renders plain text).
 */
(function () {
  'use strict';
  window.URS = window.URS || {};

  var LRC_LINE = /\[(\d{1,2}):(\d{2})(?:[.:](\d{1,3}))?\](.*)/;

  function parse(text) {
    if (!text || typeof text !== 'string') return null;
    var lines = text.split(/\r?\n/);
    var out = [];
    for (var i = 0; i < lines.length; i++) {
      var m = lines[i].match(LRC_LINE);
      if (!m) continue;
      var mm = parseInt(m[1], 10);
      var ss = parseInt(m[2], 10);
      var ms = m[3] ? parseInt(m[3], 10) : 0;
      // Normalize: 2-digit ms is centiseconds, 3-digit is milliseconds.
      if (m[3] && m[3].length === 2) ms *= 10;
      var time = mm * 60 + ss + ms / 1000;
      var content = (m[4] || '').trim();
      out.push({ time: time, text: content });
    }
    if (!out.length) return null;
    out.sort(function (a, b) { return a.time - b.time; });
    return out;
  }

  function throttle(fn, wait) {
    var last = 0;
    var pending = null;
    return function () {
      var now = Date.now();
      var args = arguments;
      var self = this;
      var remaining = wait - (now - last);
      if (remaining <= 0) {
        if (pending) { clearTimeout(pending); pending = null; }
        last = now;
        fn.apply(self, args);
      } else if (!pending) {
        pending = setTimeout(function () {
          last = Date.now();
          pending = null;
          fn.apply(self, args);
        }, remaining);
      }
    };
  }

  function render(container, lines) {
    if (!container) return [];
    container.innerHTML = '';
    var spans = [];
    for (var i = 0; i < lines.length; i++) {
      var span = document.createElement('span');
      span.className = 'urs-lyric-line';
      if (!lines[i].text) span.classList.add('urs-lyric-line--blank');
      span.setAttribute('data-line-index', String(i));
      span.setAttribute('data-time', String(lines[i].time));
      span.textContent = lines[i].text;
      container.appendChild(span);
      spans.push(span);
    }
    return spans;
  }

  function attach(audio, container, lines, opts) {
    if (!audio || !container || !lines || !lines.length) return null;
    var spans = render(container, lines);
    var spans2 = (opts && opts.mirror) ? render(opts.mirror, lines) : null;
    var currentIdx = -1;

    function findActive(t) {
      var lo = 0, hi = lines.length - 1, ans = -1;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        if (lines[mid].time <= t) { ans = mid; lo = mid + 1; } else { hi = mid - 1; }
      }
      return ans;
    }

    var onUpdate = throttle(function () {
      var idx = findActive(audio.currentTime);
      if (idx === currentIdx) return;
      if (currentIdx >= 0 && spans[currentIdx]) spans[currentIdx].classList.remove('is-active');
      if (spans2 && currentIdx >= 0 && spans2[currentIdx]) spans2[currentIdx].classList.remove('is-active');
      currentIdx = idx;
      if (idx >= 0 && spans[idx]) {
        spans[idx].classList.add('is-active');
        spans[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (spans2 && idx >= 0 && spans2[idx]) {
        spans2[idx].classList.add('is-active');
        spans2[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 200);

    function onSeek() {
      currentIdx = -1;
      onUpdate();
    }

    audio.addEventListener('timeupdate', onUpdate);
    audio.addEventListener('seeked', onSeek);
    audio.addEventListener('ended', function () {
      if (currentIdx >= 0 && spans[currentIdx]) spans[currentIdx].classList.remove('is-active');
      if (spans2 && currentIdx >= 0 && spans2[currentIdx]) spans2[currentIdx].classList.remove('is-active');
      currentIdx = -1;
    });

    return {
      destroy: function () {
        audio.removeEventListener('timeupdate', onUpdate);
        audio.removeEventListener('seeked', onSeek);
        spans.forEach(function (s) { s.classList.remove('is-active'); });
        if (spans2) spans2.forEach(function (s) { s.classList.remove('is-active'); });
      }
    };
  }

  window.URS.LRC = {
    parse: parse,
    attach: attach,
    render: render
  };
})();
